import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Select, Card, Typography, Space, Statistic } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import Layout from "../../ReusableComponents/Layout";
import getService from "../../Redux/APIs/ServiceAPIs/get";
import getAllCompanies from "../../Redux/APIs/CompanyAPIs/getAll";

import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";

const { Title } = Typography;

const containerStyle = {
  width: "100%",
  height: "100%",
  minHeight: "70vh",
};

const Locations = () => {
  const dispatch = useDispatch();
  const [services, setServices] = useState([]);
  const [allCompanies, setAllCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedService, setSelectedService] = useState("all");

  useEffect(() => {
    dispatch(getAllCompanies("all", setAllCompanies));
    dispatch(getService(setServices));
  }, []);

  const onSelectedService = (value) => {
    dispatch(getAllCompanies(value, setAllCompanies));
    setSelectedService(value);
  };

  const serviceOptions = [
    { value: "all", label: "All Services" },
    ...services.map((s) => ({ value: s?._id, label: s?.name })),
  ];

  return (
    <Layout>
      <Space style={{ marginBottom: 16 }} align="center">
        <Title level={4} style={{ margin: 0 }}>
          <EnvironmentOutlined /> Locations
        </Title>
        <Select
          value={selectedService}
          onChange={onSelectedService}
          options={serviceOptions}
          style={{ width: 200 }}
        />
        <Statistic value={allCompanies?.length} suffix="companies" />
      </Space>

      <Card bodyStyle={{ padding: 0, overflow: "hidden", borderRadius: 8 }}>
        <LoadScript googleMapsApiKey={process.env.REACT_APP_MAP_KEY}>
          {allCompanies?.length > 0 ? (
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={{ lat: 53.5, lng: 0 }}
              zoom={6}
            >
              {allCompanies?.map((comp) => (
                <Marker
                  key={comp?._id || comp?.address?.latitude}
                  position={{
                    lat: parseFloat(comp?.address?.latitude),
                    lng: parseFloat(comp?.address?.longitude),
                  }}
                  onClick={() => setSelectedCompany(comp)}
                />
              ))}
              {selectedCompany && (
                <InfoWindow
                  onCloseClick={() => setSelectedCompany(null)}
                  position={{
                    lat: parseFloat(selectedCompany?.address?.latitude),
                    lng: parseFloat(selectedCompany?.address?.longitude),
                  }}
                >
                  <div>
                    <h3>{selectedCompany?.name}</h3>
                    <p>{selectedCompany?.address?.address1}</p>
                    <p>{selectedCompany?.address?.address2}</p>
                    <p>{selectedCompany?.address?.town}</p>
                    <p>{selectedCompany?.address?.postCode}</p>
                  </div>
                </InfoWindow>
              )}
            </GoogleMap>
          ) : (
            <div style={{ padding: 40, textAlign: "center" }}>
              <Title level={5} type="secondary">No Companies Found</Title>
            </div>
          )}
        </LoadScript>
      </Card>
    </Layout>
  );
};

export default Locations;
